/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An access rule a catalog platform offers in place of its default.
 */
export type WorkloadPlatformSubjectAlternative = {
  /**
   * Identifies the choice within the platform.
   */
  key: string;
  /**
   * What the operator chooses it by.
   */
  label: string;
  /**
   * The subject with {key} placeholders for rule-tier variables; the stem, for a wildcard rule.
   */
  template: string;
  /**
   * Whether the rule is the filled template followed by *.
   */
  wildcard: boolean;
};

/** @internal */
export const WorkloadPlatformSubjectAlternative$inboundSchema: z.ZodMiniType<
  WorkloadPlatformSubjectAlternative,
  unknown
> = z.object({
  key: z.string(),
  label: z.string(),
  template: z.string(),
  wildcard: z.boolean(),
});

export function workloadPlatformSubjectAlternativeFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadPlatformSubjectAlternative, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      WorkloadPlatformSubjectAlternative$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadPlatformSubjectAlternative' from JSON`,
  );
}
